import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './Education.css';

const Education = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Education Services | Digi Network" 
                description="Learn more about our Education services to grow your business online with Digi Network." 
                canonical="/industries/education/education" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">Education Industry</div>
                        <h1>Digital Marketing for Education</h1>
                        <p>Attract students, increase enrollments, and grow your educational institution with targeted digital marketing strategies. We understand the unique challenges educational institutions face in today's competitive market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add Education Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>Education Marketing Services</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for educational institutions</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Education SEO</h3>
                            <p>Rank for program keywords, attract prospective students, and build authority in your field. Our education SEO strategies help schools and universities dominate search results for relevant programs and courses.</p>
                            <ul>
                                <li>Program & course optimization</li>
                                <li>Local SEO for schools</li>
                                <li>Google My Business for education</li>
                                <li>Content marketing for education</li>
                                <li>Education directory listings</li>
                                <li>Student testimonial optimization</li>
                            </ul>
                            <Link to="/industries/education/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Education Paid Ads</h3>
                            <p>Drive applications and enrollments with targeted advertising campaigns. Our targeted ad campaigns reach prospective students actively searching for educational programs.</p>
                            <ul>
                                <li>Google Ads for education</li>
                                <li>Facebook & Instagram ads</li>
                                <li>LinkedIn education campaigns</li>
                                <li>Lead generation campaigns</li>
                                <li>Retargeting strategies</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/education/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Education Website Design</h3>
                            <p>Professional education websites with program information, applications, and virtual tours. Our education websites are designed to showcase your programs and make it easy for students to apply.</p>
                            <ul>
                                <li>School & university websites</li>
                                <li>Online application forms</li>
                                <li>Program showcase pages</li>
                                <li>Student portal integration</li>
                                <li>Mobile-responsive design</li>
                                <li>Virtual campus tours</li>
                            </ul>
                            <Link to="/industries/education/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Education Email Marketing</h3>
                            <p>Nurture prospects with program information, application reminders, and enrollment campaigns. Build lasting relationships with prospective students through strategic email communication.</p>
                            <ul>
                                <li>Prospect nurturing sequences</li>
                                <li>Application deadline reminders</li>
                                <li>Program information emails</li>
                                <li>Alumni engagement campaigns</li>
                                <li>Event invitation emails</li>
                                <li>Newsletter campaigns</li>
                            </ul>
                            <Link to="/industries/education/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Education CRM & Automation</h3>
                            <p>Manage student leads, automate follow-ups, and track enrollment with GoHighLevel. Streamline your admissions process and student communication workflows.</p>
                            <ul>
                                <li>Student lead management</li>
                                <li>Automated application follow-ups</li>
                                <li>Enrollment tracking</li>
                                <li>Multi-channel communication</li>
                                <li>Student journey automation</li>
                                <li>Alumni relationship management</li>
                            </ul>
                            <Link to="/industries/education/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title"> Our Education Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for educational institutions</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Institution Analysis</h3>
                            <p>We analyze your educational institution, programs, and competitive landscape to understand your unique positioning. Our team conducts comprehensive audits of your current marketing and student acquisition strategies.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Enrollment-Focused Strategy</h3>
                            <p>We develop a customized marketing strategy that focuses on driving applications and enrollments. Every tactic is designed to attract qualified students who are a good fit for your programs.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Multi-Channel Implementation</h3>
                            <p>We implement the marketing strategy across all channels, from content marketing to paid ads to email. Our team handles everything from program promotion to application optimization.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Student Journey Optimization</h3>
                            <p>We continuously monitor performance, analyze student feedback, and optimize campaigns for better results. Regular reporting keeps you informed of your application and enrollment metrics.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Education Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why Educational Institutions Choose Digi Network</h2>
                    <p className="why-intro">Trusted by educational professionals across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Enrollment-Focused</h3>
                            <p>Every strategy is designed to drive applications and increase student enrollments. We understand that educational success is measured in enrollments, not just website traffic.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Education Expertise</h3>
                            <p>We understand the education market and create campaigns that attract quality students. Our team has extensive experience working with schools, universities, and training institutions.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Student Journey Optimization</h3>
                            <p>We optimize every stage from awareness to application to enrollment. Our strategies help you guide prospective students through their decision-making process.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Proven Results</h3>
                            <p>We've helped educational institutions increase enrollments by 250%+ through targeted marketing. Our data-driven approach delivers measurable results that directly impact your enrollment numbers.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for Educational Institutions</h2>
                    <p className="section-intro">How our marketing services help you grow your educational institution</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More Applications</h3>
                            <p>Generate more applications through targeted marketing campaigns that reach prospective students. Our strategies focus on converting interested prospects into applicants.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Online Visibility</h3>
                            <p>Dominate search results for educational programs and courses. When prospective students search for your programs, they'll find your institution first.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Improved Student Engagement</h3>
                            <p>Build lasting relationships with prospective students through email marketing and content. Keep your institution top-of-mind throughout the application process.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Increased Enrollment Rates</h3>
                            <p>Improve enrollment rates through better application follow-ups and engagement. Convert more applicants into enrolled students with strategic nurturing.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Higher Quality Students</h3>
                            <p>Attract higher quality students who are a good fit for your programs. Our strategies help you reach students who are genuinely interested in your offerings.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many educational institutions still rely on basic marketing methods.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Education Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Grow Your Enrollment?</h2>
                    <p>Let's discuss how we can help you attract more students and grow your educational institution.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Education;
